import { Box, IconButton, Menu, Typography } from '@mui/material'
import ErrorOutlineOutlinedIcon from '@mui/icons-material/ErrorOutlineOutlined'
import MoreVertIcon from '@mui/icons-material/MoreVert'

import React from 'react'
import useStyles from './useStyles'
import { useNavigate, useParams } from 'react-router-dom'
import ManageSearchIcon from '@mui/icons-material/ManageSearch'
import RuleFolderIcon from '@mui/icons-material/RuleFolder'
import PersonOutlineIcon from '@mui/icons-material/PersonOutline'

export default function ModalMenuItem ({ item, setLoading }) {
  const [anchorEl, setAnchorEl] = React.useState(null)
  const open = Boolean(anchorEl)

  const handleClickMenu = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  // const listSeeMoreOrganization = (anchor) => (
  //   <Box className={classes.stepperStyleSeeMore} role="presentation">
  //     <StepperSeeMoreInstances
  //       setstateSeeMore={setstateSeeMore}
  //       item={item}
  //       setLoading={setLoading}
  //     />
  //   </Box>
  // )

  return (
    <>
      <MoreVertIcon
        sx={{
          color: '#026873',
          '&:hover': {
            color: '#00FFAC'
          }
        }}
        onClick={handleClickMenu}
      />
      <Menu
        id="basic-menu"
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'center'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center'
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
      >
        <FiltersList item={item} onClose={handleClose} />
      </Menu>
    </>
  )
}

function FiltersList ({ item, onClose }) {
  const classes = useStyles()
  const navigate = useNavigate()
  const { id } = useParams()

  return (
    <Box
      sx={{
        height: 200,
        width: 280
      }}
      className={classes.boxStyle}
    >
      <IconButton
        onClick={() => {
          onClose()
          navigate(`/ME/applicationInstances/${item.applicationInstanceId}`)
        }}
      >
        <Box className={classes.boxTypography}>
          <ErrorOutlineOutlinedIcon className={classes.hoverButtonRotate} />
          <Typography className={classes.typographyStyle}>
            Ver detalles
          </Typography>
        </Box>
      </IconButton>
      <IconButton
        onClick={() => {
          onClose()
          navigate(`/ME/applicationInstances/${id}/statusME`)
        }}
      >
        <Box className={classes.boxTypography}>
          <ManageSearchIcon className={classes.hoverButton} />
          <Typography className={classes.typographyStyle}>
            Verificar el estado de inicialización Mi Estudio
          </Typography>
        </Box>
      </IconButton>
      <IconButton
        onClick={() => {
          onClose()
          navigate(
            `/suborganizations/${item.baseSuborganizationId}/statusStorage`
          )
        }}
      >
        <Box className={classes.boxTypography}>
          <RuleFolderIcon className={classes.hoverButton} />
          <Typography className={classes.typographyStyle}>
            Verificar estructura inicial de almacenamiento
          </Typography>
        </Box>
      </IconButton>
      <IconButton
        onClick={() => {
          onClose()
          navigate(
            `/ME/applicationInstances/${item.applicationInstanceId}/users`
          )
        }}
      >
        <Box className={classes.boxTypography}>
          <PersonOutlineIcon className={classes.hoverButton} />
          <Typography className={classes.typographyStyle}>
            Configurar usuarios asociados{' '}
          </Typography>
        </Box>
      </IconButton>
    </Box>
  )
}
